export const FooterExternalContent = [
  {
    title: `Copyright © ${new Date().getFullYear()} PerksBar Limited. All Rights Reserved.`,
    href: '/',
  },
  // {
  //   title: 'Help Center',
  //   href: '/',
  // },
  {
    title: 'Terms of Use',
    href: '/terms-of-use',
  },
  {
    title: 'Privacy Policy',
    href: '/privacy-policy',
  },
];

export default FooterExternalContent;
